import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FasServiceTableComponent } from 'fas-services';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { PlatformUsersComponent } from './platform-users.component';
import { UsersDetailsComponent } from './users-details/users-details.component';
import { UsersAddSubscriptionsComponent } from './users-add-subscriptions/users-add-subscriptions.component';
import { ClientDeviceComponent } from '../../shared/components/client-device/client-device.component';

@NgModule({
  declarations: [PlatformUsersComponent, UsersDetailsComponent, UsersAddSubscriptionsComponent],
  imports: [CommonModule, FormsModule, FasServiceTableComponent, AutoCompleteModule, ButtonModule, CalendarModule,
    CheckboxModule, ConfirmDialogModule, DropdownModule, InputTextModule, TableModule, TabViewModule, TooltipModule,
    ClientDeviceComponent],
  providers: [ConfirmationService, DialogService]
})
export class PlatformUsersModule {}
